import React from "react";
import { JoyrideOnboardingTemplate } from "themes/common/components";

function JoyrideOnboarding(props) {
  return <JoyrideOnboardingTemplate {...props} />;
}

export default JoyrideOnboarding;
